import { communityService } from '../services/community.service';

/**
 * Unified Platform community for the Messages card (IMP-2081).
 *
 * Holds the raw UP response body. The normalizing lives in
 * src/utils/memberCommunity.js so it stays pure and testable, and the card
 * reads it through src/hooks/useMemberCommunity.js.
 *
 * Fails closed: any error leaves `payload` null, the resolver returns null,
 * and the card renders nothing. There is deliberately no error state and no
 * retry — the acceptance criteria ask for none, and a hidden card beats a
 * broken one.
 */
const communityModel = {
  state: {
    payload: null,
    isLoaded: false,
  },
  reducers: {
    setData(state, payload) {
      return { ...state, ...payload };
    },
  },
  effects: dispatch => ({
    async getMyCommunities() {
      try {
        const payload = await communityService.fetchMyCommunities();
        this.setData({ payload, isLoaded: true });
      } catch (error) {
        // Network failure, CORS rejection, timeout, 401 — all the same to the
        // card. Never logged with the response, which carries the token's
        // scope.
        this.setData({ payload: null, isLoaded: true });
      }
    },
  }),
};

export default communityModel;
